export default "__VITE_ASSET__d2693780__"